export default {
  'dashboard.title': '仪表盘',
  'dashboard.welcome': '欢迎回来，{{name}}',
  'dashboard.subtitle': '这是今天需要你关注的事项',

  'dashboard.menu.group.main': '主页',
  'dashboard.menu.group.products': '产品',
  'dashboard.menu.group.account': '账户',
  'dashboard.menu.welcomeBack': '欢迎回来',
  'dashboard.menu.backToHome': '返回首页',

  'dashboard.status.quotes': '待处理报价',
  'dashboard.status.orders': '进行中订单',
  'dashboard.status.messages': '未读消息',
  'dashboard.status.aiPreviews': 'AI 预览已就绪',
  'dashboard.status.payments': '待付款项',
  'dashboard.status.shipping': '运输中',

  'dashboard.actionRequired': '需要处理',
  'dashboard.actionPriority.high': '高',
  'dashboard.actionPriority.medium': '中',
  'dashboard.actionPriority.low': '低',

  'dashboard.recentQuotes.title': '最近报价',
  'dashboard.recentQuotes.quoteNumber': '报价 #',
  'dashboard.recentQuotes.product': '产品',
  'dashboard.recentQuotes.finish': '后加工',
  'dashboard.recentQuotes.quantity': '数量',
  'dashboard.recentQuotes.status': '状态',
  'dashboard.recentQuotes.amount': '金额',
  'dashboard.recentQuotes.view': '查看报价',
  'dashboard.recentQuotes.viewAll': '查看全部报价',
  'dashboard.recentQuotes.requestNew': '申请新报价',
  'dashboard.recentQuotes.empty': '还没有报价。为你的包装需求申请一份报价，从这里开始吧。',

  'dashboard.aiPreviews.title': 'AI 后加工预览',
  'dashboard.aiPreviews.original': '原图',
  'dashboard.aiPreviews.generated': '生成图',
  'dashboard.aiPreviews.product': '产品',
  'dashboard.aiPreviews.finish': '后加工',
  'dashboard.aiPreviews.status': '状态',
  'dashboard.aiPreviews.view': '查看预览',
  'dashboard.aiPreviews.requestQuote': '申请报价',
  'dashboard.aiPreviews.readyCta': '准备好申请报价',
  'dashboard.aiPreviews.empty': '还没有 AI 预览。生成一次预览，看看你的包装效果如何。',

  'dashboard.orders.title': '进行中订单',
  'dashboard.orders.orderNumber': '订单 #',
  'dashboard.orders.quoteRef': '报价单号',
  'dashboard.orders.product': '产品',
  'dashboard.orders.payment': '付款',
  'dashboard.orders.production': '生产',
  'dashboard.orders.shipping': '运输',
  'dashboard.orders.total': '合计',
  'dashboard.orders.delivery': '预计交付',
  'dashboard.orders.view': '查看订单',
  'dashboard.orders.empty': '还没有进行中的订单。已确认的报价会在订单确认后显示在这里。',

  'dashboard.payments.title': '付款状态',
  'dashboard.payments.date': '日期',
  'dashboard.payments.reference': '参考号',
  'dashboard.payments.amount': '金额',
  'dashboard.payments.status': '状态',
  'dashboard.payments.method': '方式',
  'dashboard.payments.empty': '还没有付款记录。',

  'dashboard.shipping.title': '运输状态',
  'dashboard.shipping.order': '订单 #',
  'dashboard.shipping.carrier': '承运商',
  'dashboard.shipping.tracking': '运单号',
  'dashboard.shipping.status': '状态',
  'dashboard.shipping.delivery': '预计交付',
  'dashboard.shipping.view': '查看详情',
  'dashboard.shipping.empty': '还没有进行中的运输。',

  'dashboard.messages.title': '消息中心',
  'dashboard.messages.related': '关联',
  'dashboard.messages.unread': '未读',
  'dashboard.messages.open': '打开消息',
  'dashboard.messages.empty': '还没有消息。',

  'dashboard.samples.title': '样品生产申请',
  'dashboard.samples.requestNumber': '申请 #',
  'dashboard.samples.product': '产品',
  'dashboard.samples.finish': '后加工',
  'dashboard.samples.quantity': '数量',
  'dashboard.samples.status': '状态',
  'dashboard.samples.cost': '预估费用',
  'dashboard.samples.view': '查看样品申请',
  'dashboard.samples.empty': '还没有样品申请。',

  'dashboard.files.title': '已上传文件',
  'dashboard.files.name': '文件',
  'dashboard.files.type': '类型',
  'dashboard.files.purpose': '用途',
  'dashboard.files.related': '关联',
  'dashboard.files.view': '查看',
  'dashboard.files.empty': '还没有上传文件。',

  'dashboard.savedProducts.title': '收藏产品',
  'dashboard.savedProducts.category': '分类',
  'dashboard.savedProducts.sku': 'SKU',
  'dashboard.savedProducts.view': '查看产品',
  'dashboard.savedProducts.quote': '申请报价',
  'dashboard.savedProducts.preview': 'AI 预览',
  'dashboard.savedProducts.empty': '还没有收藏产品。浏览包装产品并收藏你的心仪之选吧。',

  'dashboard.company.title': '公司资料',
  'dashboard.company.completion': '已完成 {{percent}}%',
  'dashboard.company.missing': '缺失：',
  'dashboard.company.completeButton': '完善公司资料',

  'dashboard.market.title': '市场设置',
  'dashboard.market.country': '国家',
  'dashboard.market.language': '语言',
  'dashboard.market.displayCurrency': '显示货币',
  'dashboard.market.quoteBase': '报价基础货币',
  'dashboard.market.exchangeRate': '汇率截至',
  'dashboard.market.change': '更改偏好',

  'dashboard.status.quoted': '已报价',
  'dashboard.status.submitted': '已提交',
  'dashboard.status.accepted': '已接受',
  'dashboard.status.rejected': '已拒绝',
  'dashboard.status.draft': '草稿',
  'dashboard.status.expired': '已过期',

  'dashboard.paymentStatus.pending': '待处理',
  'dashboard.paymentStatus.completed': '已完成',
  'dashboard.paymentStatus.failed': '失败',
  'dashboard.paymentStatus.refunded': '已退款',
  'dashboard.paymentStatus.partial': '部分付款',

  'dashboard.productionStatus.not_started': '未开始',
  'dashboard.productionStatus.in_progress': '进行中',
  'dashboard.productionStatus.completed': '已完成',

  'dashboard.shippingStatus.not_shipped': '未发货',
  'dashboard.shippingStatus.packing': '打包中',
  'dashboard.shippingStatus.shipped': '已发货',
  'dashboard.shippingStatus.delivered': '已送达',

  'dashboard.shipmentStatus.pre_transit': '运输前',
  'dashboard.shipmentStatus.in_transit': '运输中',
  'dashboard.shipmentStatus.out_for_delivery': '派送中',
  'dashboard.shipmentStatus.delivered': '已送达',
  'dashboard.shipmentStatus.exception': '异常',

  'dashboard.sampleStatus.requested': '已申请',
  'dashboard.sampleStatus.under_review': '审核中',
  'dashboard.sampleStatus.quoted': '已报价',
  'dashboard.sampleStatus.in_production': '生产中',
  'dashboard.sampleStatus.shipped': '已发货',
  'dashboard.sampleStatus.completed': '已完成',
  'dashboard.sampleStatus.cancelled': '已取消',

  'dashboard.aiStatus.queued': '排队中',
  'dashboard.aiStatus.processing': '处理中',
  'dashboard.aiStatus.completed': '已完成',
  'dashboard.aiStatus.failed': '失败',

  'dashboard.filePurpose.image_search': '以图搜图',
  'dashboard.filePurpose.quote_reference': '报价参考',
  'dashboard.filePurpose.ai_finish_source': 'AI 后加工源图',
  'dashboard.filePurpose.sample_reference': '样品参考',
  'dashboard.filePurpose.order_document': '订单文档',

  'dashboard.seeAll': '查看全部',
  'dashboard.noData': '—',

  // Company Profile Page
  'companyProfile.pageTitle': '公司资料',
  'companyProfile.subtitle': '管理你的公司信息，用于报价、订单、运输与商务沟通。',
  'companyProfile.section.companyInfo': '公司信息',
  'companyProfile.section.contactInfo': '联系信息',
  'companyProfile.section.businessInfo': '业务信息',
  'companyProfile.section.accountStatus': '账户状态',
  'companyProfile.field.companyName': '公司名称',
  'companyProfile.field.country': '国家',
  'companyProfile.field.businessType': '业务类型',
  'companyProfile.field.website': '网站',
  'companyProfile.field.contactEmail': '联系邮箱',
  'companyProfile.field.contactPhone': '联系电话',
  'companyProfile.field.taxId': '税号 / 增值税号',
  'companyProfile.field.companySize': '公司规模',
  'companyProfile.field.status': '状态',
  'companyProfile.status.active': '正常',
  'companyProfile.status.inactive': '停用',
  'companyProfile.status.suspended': '已暂停',
  'companyProfile.statusNotice': '如果你的公司账户状态需要复核，请联系支持。',
  'companyProfile.saveButton': '保存更改',
  'companyProfile.saving': '保存中...',
  'companyProfile.successMessage': '公司资料更新成功。',
  'companyProfile.errorMessage': '保存公司资料失败，请重试。',
  'companyProfile.validation.required': '此字段为必填项',
  'companyProfile.validation.email': '请输入有效的邮箱地址',
  'companyProfile.validation.url': '请输入有效的网址',
  'companyProfile.selectPlaceholder': '请选择...',
  'companyProfile.createdAt': '创建时间',
  'companyProfile.updatedAt': '最后更新',
};